import angular from "angular";
import bootstrap from "bootstrap";
import { cloneDeep } from "lodash";

angular
    .module('ui-sentinel.header')
    .controller('HeaderController', HeaderController);

HeaderController.$inject = ['$rootScope', '$scope', '$state', 'SentinelUiSession', 'RelayService'];

function HeaderController($rootScope, $scope, $state, SentinelUiSession, RelayService) {
    var vm = {
        references: {
            home: 'sentry'
        },
        focusName: null,
        accountName: null,
        showNavigation: showNavigation,
        showLogout: showLogout,
        showMenu: false,
        showAdminMenu: showAdminMenu,
        showAccountMenu: showAccountMenu,
        showSystemAdminMenu: showSystemAdminMenu,
        showAccountAdminMenu: showAccountAdminMenu,
        showAccountEditorMenu: showAccountEditorMenu,
        showAccountEditorNewMenu: showAccountEditorNewMenu,
        showNewMenuItem: showNewMenuItem,
        showAccountObserverMenu: showAccountObserverMenu,
        showSystemAdminFulfillmentMenu: showSystemAdminFulfillmentMenu,
        isSuntronicAdmin: isSuntronicAdmin,
        logout: logout,
        go: go,
        toggleMenu: toggleMenu,
        navigateToParent: navigateToParent,
        clearFocus: clearFocus,
        changeFocus: changeFocus,
        changePassword: changePassword,
        session: SentinelUiSession,
        hasTitle: hasTitle,
        accountDisplayName: accountDisplayName,
        accountButtonDisplayNameNarrow: accountButtonDisplayNameNarrow,
        isOrs: $rootScope.isOrs,
        // Relay editing is granted to named individuals in API configuration, so the client cannot
        // work it out from the session alone; it asks the API once and caches the answer.
        relayPermissions: { canEdit: false, isEntitled: false },
        isOrsTopLevel: undefined,
        isFocused: undefined,
        orsSubAccountHide: () => {
            return vm.isOrsTopLevel && vm.isFocused;
        },
    };
    activate();

    (function ($bs) {
        const CLASS_NAME = 'has-child-dropdown-show';
        $bs.Dropdown.prototype.toggle = function (_orginal) {
            return function () {
                document.querySelectorAll('.' + CLASS_NAME).forEach(function (e) {
                    e.classList.remove(CLASS_NAME);
                });
                let dd = this._element.closest('.dropdown').parentNode.closest('.dropdown');
                for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
                    dd.classList.add(CLASS_NAME);
                }
                return _orginal.call(this);
            }
        }($bs.Dropdown.prototype.toggle);

        document.querySelectorAll('.dropdown').forEach(function (dd) {
            dd.addEventListener('hide.bs.dropdown', function (e) {
                if (this.classList.contains(CLASS_NAME)) {
                    this.classList.remove(CLASS_NAME);
                    e.preventDefault();
                }
                e.stopPropagation(); // do not need pop in multi level mode
            });
        });
    })(bootstrap);

    return vm;

    function activate() {
        $scope.$watch(
            function () {
                return SentinelUiSession.focus;
            },
            function (focus) {
                vm.isFocused = focus ? focus.isFocused : undefined;

                if (!focus || focus.id === SentinelUiSession.user.accountId) {
                    vm.focusName = null;
                } else {
                    vm.focusName = focus.name;
                }
            }
        );
        $scope.$watch(
            function () {
                return SentinelUiSession.user;
            },
            function (user) {
                vm.isOrsTopLevel = user ? user.isOrsTopLevel : undefined;
                vm.relayPermissions = { canEdit: false, isEntitled: false };
                if (user) {
                    vm.accountName = SentinelUiSession.user.accountName;
                    RelayService.permissions().then(function (permissions) {
                        if (SentinelUiSession.user === user) {
                            vm.relayPermissions = permissions;
                        }
                    }, function () {});
                }
            }
        );
    }

    function showNavigation() {
        return SentinelUiSession.user && SentinelUiSession.user.isEulaAgreement && true;
    }

    function showLogout() {
        return SentinelUiSession.user && !SentinelUiSession.user.isEulaAgreement && true;
    }

    function showSystemAdminMenu() {
        return SentinelUiSession.user && SentinelUiSession.user.isSystemAdmin;
    }

    function showSystemAdminFulfillmentMenu() {
        return SentinelUiSession.user && (SentinelUiSession.user.isSystemAdmin || isSuntronicAdmin());
    }

    function isSuntronicAdmin() {
        return SentinelUiSession.user && SentinelUiSession.user.isSuntronic && SentinelUiSession.user.isAccountAdmin;
    }

    function showAdminMenu() {
        return (SentinelUiSession.user && SentinelUiSession.user.isAnAdmin);
    }

    function showAccountMenu() {
        return (SentinelUiSession.user && !SentinelUiSession.user.isAnAdmin) || (SentinelUiSession.user && SentinelUiSession.user.isAnAdmin && SentinelUiSession.focus.id !== SentinelUiSession.user.accountId);
    }

    function showSupportAdminMenu() {
        return (SentinelUiSession.user && SentinelUiSession.user.isSupportAdmin);
    }

    function showSupportObserverMenu() {
        return (SentinelUiSession.user && SentinelUiSession.user.isSupportObserver);
    }

    function showAccountAdminMenu() {
        return (SentinelUiSession.user && SentinelUiSession.user.isAccountAdmin);
    }

    function showAccountEditorMenu() {
        return (SentinelUiSession.user && SentinelUiSession.user.isAccountEditor);
    }

    function showAccountEditorNewMenu() {
        return SentinelUiSession.accountEditorCanCreate();
    }

    function showNewMenuItem() {
        return showAdminMenu() || showAccountAdminMenu() || showAccountEditorNewMenu();
    }

    function showAccountObserverMenu() {
        return (SentinelUiSession.user && SentinelUiSession.user.isAccountObserver);
    }

    function go(state) {
        vm.showMenu = false;
        // $('#offcanvas').removeClass('show');

        $('#closeButton').click();

        if ($state.current.name !== state) {
            $state.go(state);
        }
    }

    function logout() {
        vm.showMenu = false;
        SentinelUiSession.logout().then(function () {
            $state.go('login');
        });
    }

    function toggleMenu() {
        vm.showMenu = !vm.showMenu;
    }

    function navigateToParent() {
        $state.go($state.current.data.parentState);
    }

    function hasTitle() {
        return $state.current?.data?.parentState || $state.current?.data?.pageTitle || $state.current?.data?.subTitle;
    }

    function accountDisplayName() {
        return this.focusName || this.accountName;
    }

    function accountButtonDisplayNameNarrow() {
        return this.isOrs && this.hasTitle() ? '' : this.accountDisplayName();
    }

    function clearFocus() {
        vm.focusName = null;
        SentinelUiSession.clearFocus();
        $state.go('accounts.list');
    }

    function changeFocus() {
        $state.go('accounts.list');
    }

    function changePassword() {
        const returnState = $state.current.name;
        const returnStateParams = cloneDeep($state.params);
        $state.go('logins.password', { referrer: returnState, referrerParams: returnStateParams });
    }
}
